// extracted by mini-css-extract-plugin
export var linkContainer = "link-module--linkContainer--INPLv";
export var link = "link-module--link--p8sKp";